<template>
  <div class="px-3 px-md-0">
    <v-btn
      :small="$vuetify.breakpoint.mdAndDown"
      :block="$vuetify.breakpoint.smAndDown"
      :class="get_tab_class('1')"
      link
      :to="{ name: 'undergraduate_explore' }"
    >
      <h5>{{ $t("menu.explore_undergraduate") }}</h5>
    </v-btn>
    <v-btn
      :small="$vuetify.breakpoint.mdAndDown"
      :block="$vuetify.breakpoint.smAndDown"
      :class="get_tab_class('2')"
      link
      :to="{ name: 'master_explore' }"
    >
      <h5>{{ $t("menu.explore_master") }}</h5>
    </v-btn>
    <v-btn
      :small="$vuetify.breakpoint.mdAndDown"
      :block="$vuetify.breakpoint.smAndDown"
      :class="get_tab_class('3')"
      link
      :to="{ name: 'phd_explore' }"
    >
      <h5>{{ $t("menu.explore_phd") }}</h5>
    </v-btn>

    <v-btn
      :small="$vuetify.breakpoint.smAndDown || $vuetify.breakpoint.lgAndUp"
      :x-small="$vuetify.breakpoint.mdOnly"
      :block="$vuetify.breakpoint.smAndDown"
      :class="get_tab_class('undergraduate_announcement')"
      link
      :to="{ name: 'undergraduate_announcement' }"
    >
      <h5>{{ $t("registered_program_list.result_announced_1") }}</h5>
    </v-btn>
    <v-btn
      :small="$vuetify.breakpoint.smAndDown || $vuetify.breakpoint.lgAndUp"
      :x-small="$vuetify.breakpoint.mdOnly"
      :block="$vuetify.breakpoint.smAndDown"
      :class="get_tab_class('graduate_announcement')"
      link
      :to="{ name: 'graduate_announcement' }"
    >
      <h5>{{ $t("registered_program_list.result_announced_2") }}</h5>
    </v-btn>
  </div>
</template>

<script>
export default {
  name: "LauncherTabs",
  props: {
    page: String,
  },
  methods: {
    get_tab_class(page) {
      const active = page === this.page ? " active_tab" : "";
      if (page === "2") {
        const round = this.$vuetify.breakpoint.smAndDown
          ? " mb-2"
          : " rounded-0";
        return "tab" + active + round;
      } else if (page === "3") {
        const round = this.$vuetify.breakpoint.smAndDown
          ? " mb-2"
          : " rounded-0 rounded-tr-lg";
        return "tab" + active + round;
      } else if (page === "1") {
        const round = this.$vuetify.breakpoint.smAndDown
          ? " mb-2"
          : " rounded-0 rounded-tl-lg";
        return "tab" + active + round;
      } else if (page === "undergraduate_announcement") {
        const round = this.$vuetify.breakpoint.smAndDown
          ? " mb-2"
          : " rounded-0 rounded-tl-lg ml-3 mt-2";
        return "tab_announcement" + active + round;
      } else if (page === "graduate_announcement") {
        const round = this.$vuetify.breakpoint.smAndDown
          ? " mb-2"
          : " rounded-0 rounded-tr-lg mt-2";
        return "tab_announcement" + active + round;
      } else return "";
    },
  },
};
</script>

<style scoped>
.active_tab.tab {
  font-weight: bolder;
  background-color: black !important;
  color: whitesmoke;
}

.tab_announcement {
  background-color: #fff9 !important;
}
.active_tab.tab_announcement {
  font-weight: bolder;
  background-color: black !important;
  color: whitesmoke;
}
</style>
